import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  titles: [],
  /** Last GetTitlesCall `type` written into `titles` (e.g. "presentation", "his"). */
  titlesType: null,
};

export const titleSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setTitle: (state, action) => {
      const p = action.payload;
      if (
        p &&
        typeof p === "object" &&
        !Array.isArray(p) &&
        Array.isArray(p.list)
      ) {
        state.titles = p.list;
        state.titlesType = p.type != null ? String(p.type) : null;
      } else {
        state.titles = Array.isArray(p) ? p : [];
        state.titlesType = null;
      }
    },
  },
});

const titleReducer = titleSlice.reducer;

export const { setTitle } = titleSlice.actions;

export default titleReducer;
